module.exports = __webpack_public_path__ + "static/media/CIPLA_F1.b125debb.txt";